"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'PostEditor',
  data() {
    return {
      postData: {
        title: '',
        text: '',
        price: 0
      }
    };
  },
  methods: {
    publish() {
      this.$emit('publish', {
        ...this.postData
      });
      this.postData = {
        title: '',
        text: '',
        price: 0
      };
    }
  }
};